import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { CHANNEL, mdLabel } from "@/components/birthdays/shared";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Prefs = ({ r, mode }) => {
  const qc = useQueryClient();
  const save = useMutation({ mutationFn: (body) => api.put(`/birthdays/patient/${r.patient_id}/prefs`, body),
    onSuccess: () => { toast.success("Preference saved"); qc.invalidateQueries({ queryKey: ["birthdays"] }); },
    onError: () => toast.error("Could not save") });
  return (
    <div className="flex flex-wrap items-center justify-end gap-3">
      <Select value={r.preferred_channel || "none"} onValueChange={(v) => save.mutate({ preferred_channel: v })} disabled={mode !== "preferred"}>
        <SelectTrigger className="h-7 w-32 text-xs" title={mode !== "preferred" ? "Only used when Channel is set to \"Patient's preferred channel\"" : undefined} data-testid={`bday-pref-${r.patient_id}`}><SelectValue /></SelectTrigger>
        <SelectContent><SelectItem value="none">No preference</SelectItem><SelectItem value="sms">Prefers text</SelectItem><SelectItem value="email">Prefers email</SelectItem></SelectContent>
      </Select>
      <label className="flex items-center gap-1.5 text-xs text-slate-600">
        <Switch checked={!r.birthday_opt_out} onCheckedChange={(v) => save.mutate({ birthday_opt_out: !v })} data-testid={`bday-optout-${r.patient_id}`} />Greet</label>
    </div>
  );
};

export const BirthdayUpcoming = ({ rows, mode }) => (
  <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white" data-testid="bday-upcoming">
    <table className="w-full text-sm">
      <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
        <tr><th className="px-3 py-2">Patient</th><th className="px-3 py-2">Greeting on</th><th className="px-3 py-2">Will send by</th><th className="px-3 py-2 text-right">Patient settings</th></tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.patient_id} data-testid={`bday-upcoming-${r.patient_id}`} className="border-t border-slate-100">
            <td className="px-3 py-2.5 font-medium text-slate-800">{r.name}<span className="block text-[11px] font-normal text-slate-400">birthday {mdLabel(r.birthday)}</span></td>
            <td className="whitespace-nowrap px-3 py-2.5 text-slate-600">{new Date(`${r.greet_date}T12:00:00`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</td>
            <td className="px-3 py-2.5 text-slate-600">{r.channel ? CHANNEL[r.channel] : <span className="text-xs text-slate-500">Will be skipped: {r.skip_reason}</span>}</td>
            <td className="px-3 py-2.5"><Prefs r={r} mode={mode} /></td>
          </tr>
        ))}
      </tbody>
    </table>
    {rows.length === 0 && <p className="px-4 py-8 text-center text-sm text-slate-500">No birthdays in the next 7 days.</p>}
  </div>
);
